import { Controller, useFormContext } from 'react-hook-form';

import Checkbox from '~/components/ui/Checkbox';

type FormCheckboxProps = {
  name: string;
  label?: string;
  [key: string]: any;
};

export function FormCheckbox({ name, ...props }: FormCheckboxProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, formState }) => (
        <Checkbox {...props} checked={value} onChange={onChange} error={formState.errors[name]?.message} />
      )}
    />
  );
}
